// extracted by mini-css-extract-plugin
module.exports = {"documentsContainer":"styles_documentsContainer__3cHCq","tileIcon":"styles_tileIcon__3RMc4"};